var pjax = require('./lib/pjax');

//card.js

document.addEventListener("latte:init", init);
function init () {

  //solve conflict with containing div's click event and affirm msg anchor tag
  $('.product-price-affirm-msg').click(function (e) {
    e.stopPropagation();
  });

  $('.js-product-click').click(function (e) {
    e.preventDefault();
    pjax.loadUrl($(this).attr('data-url'), {scrollTo:true});
  });


}



//////////////////
// WEBPACK FOOTER
// ./public/js/card.js
// module id = 68
// module chunks = 0